module.exports = __webpack_public_path__ + "img/android.1aef405f.svg";